<template>
  <div class="fair-pay-menu">
    <HorizontalMenu
      :items="items"
      :value="value"
      size="small"
      :bottom-line="false"
      @onChange="handleOnChange"
      @onSameTabClick="handleOnSameTabClick"
    />
  </div>
</template>

<script setup>
import HorizontalMenu from "@components/HorizontalMenu/HorizontalMenu.vue";
import { FAIR_PAY_MENU_ITEMS, FAIR_PAY_TAB } from "./fairPayMenuConstants";

defineProps({
  items: {
    type: Array,
    default: () => FAIR_PAY_MENU_ITEMS,
  },
  value: {
    type: Number,
    default: FAIR_PAY_TAB.PAY_PLANS,
  },
});

const emit = defineEmits(["onChange", "input", "onSameTabClick"]);

function handleOnChange(index) {
  emit("onChange", index);
  emit("input", index);
}

function handleOnSameTabClick(index) {
  emit("onSameTabClick", index);
}
</script>

<style scoped>
.fair-pay-menu {
  width: 100%;
}

::v-deep .horizontal-small-tab.horizontal-tab .v-tabs-slider-wrapper {
  bottom: 12px !important;
}

/* Match Figma Fair Pay menu spacing (node 2420:10643) — PerformanceMenu's
   4px padding collapses gaps between long labels; restore ~24px between items. */
::v-deep .horizontal-small-tab .menu-tabs {
  padding: 4px 0 !important;
  margin-right: 24px !important;
  margin-bottom: 15px !important;
  min-width: auto !important;
}

::v-deep .horizontal-small-tab .menu-tabs:last-child {
  margin-right: 0 !important;
}
</style>
